const action = 'forage';

const FORAGE_MAX_FOOD = 5;

const messageText = ({ success, gain }) => {
  if (!success) return `found **nothing** useful`;

  const { food } = gain;
  return `found **${food} food**`;
};

const attempt = () => {
  const result = {
    success: Math.random() < 0.9,
    gain: {
      food: 0
    },
    cost: {}
  };

  if (!result.success) return result;

  result.gain.food += Math.floor(Math.random() * FORAGE_MAX_FOOD);
  result.success = result.gain.food > 0;
  return result;
};

const executeSideEffects = (context, result) => {
  const {
    calendar,
    party: { resources, history }
  } = context;

  // History
  history.add({ action, day: calendar.step, result });

  // Update resources
  resources.delta({ ...result.gain }, context);

  // Time passes
  calendar.next(context);

  const message = { label: messageText(result), id: new Date() };
  return { message };
};

const forage = {
  title: ({ calendar, party }) => `Forage (${party.history.remainingToday(calendar.step)})`,
  hotkey: 'f',
  enabled: () => true,
  execute: context => {
    const result = attempt(context);
    const { message } = executeSideEffects(context, result);

    return { result: { message } };
  }
};

export { action as ForageType, forage as default };
